import { Api } from "../Api";

export const postProtestoAceite = async (e) => {
  const { data } = await Api.post("/log", e);
  return data;
};
